"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ThemeProvider_1 = require("../../utils/ThemeProvider");
const Utils_1 = require("../../utils/Utils");
const StyleUtils_1 = require("../../utils/StyleUtils");
const ToastProvider_1 = require("./ToastProvider");
const ToastContainer_styles_1 = require("./styles/ToastContainer.styles");
const __DEV__ = process.env.NODE_ENV !== 'production';
const ToastContainer = (props) => {
    const { children, id, className = '', testId, offsetTop = 80 } = props;
    const theme = (0, ThemeProvider_1.useTheme)();
    const toasts = (0, ToastProvider_1.useToasts)();
    if (!theme) {
        if (__DEV__) {
            console.error('`ToastContainer` component must be a child of a `ThemeProvider`');
        }
        return null;
    }
    if (!toasts) {
        if (__DEV__) {
            console.error('`ToastContainer` component must be a child of a `ToastProvider`');
        }
        return null;
    }
    const styles = (0, ToastContainer_styles_1.getToastContainerStyles)();
    const dti = (0, Utils_1.getTestIdAttribute)(testId);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ id: id, className: (0, StyleUtils_1.classNames)('ToastContainer-local', styles.mainContainer, className), style: { top: `${offsetTop}px` } }, dti, { children: children })));
};
exports.ToastContainer = ToastContainer;
